import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, dark = false }) {
  return (
    <div className="flex items-center gap-4">
      <span className="h-px w-10 bg-bronze" />
      <span
        className={`text-[11px] font-medium uppercase tracking-[0.3em] ${
          dark ? "text-champagne" : "text-bronze"
        }`}
      >
        {children}
      </span>
    </div>
  );
}
